import {
  PiChat,
  PiLightning,
  PiPaperPlaneTilt,
  PiTrendUp,
} from 'react-icons/pi'
import type { CampaignStats as CampaignStatsResponse } from 'services/campaigns'

interface StatCardProps {
  label: string
  value: string | number
  icon: React.ReactNode
}

function StatCard({ label, value, icon }: StatCardProps) {
  return (
    <div className="flex items-center gap-3 bg-surface rounded-lg border border-line p-3.5">
      <div className="size-9 rounded-lg bg-brand-active/10 flex items-center justify-center shrink-0 text-brand-active">
        {icon}
      </div>
      <div>
        <p className="text-sm text-fg-secondary">{label}</p>
        <p className="text-lg font-bold text-fg leading-tight">{value}</p>
      </div>
    </div>
  )
}

export function CampaignsStatsBar({
  stats,
}: {
  stats?: CampaignStatsResponse
}) {
  const avgRate =
    stats?.avg_interested_rate != null ? `${stats.avg_interested_rate}%` : '—'

  return (
    <div className="grid grid-cols-4 gap-3 mb-4">
      <StatCard
        label="Emails Sent"
        value={stats?.sent ?? '—'}
        icon={<PiPaperPlaneTilt size={16} />}
      />
      <StatCard
        label="Active Campaigns"
        value={stats?.active_campaigns ?? '—'}
        icon={<PiLightning size={16} />}
      />
      <StatCard
        label="Replies"
        value={stats?.replies ?? '—'}
        icon={<PiChat size={16} />}
      />
      <StatCard
        label="Avg. Interested Rate"
        value={avgRate}
        icon={<PiTrendUp size={16} />}
      />
    </div>
  )
}
